<template>
  <div class="store-card-product">
    <media class="item-img" :media="media" width="90" :alt="model.name" />

    <div class="item-title">
      {{ model.name }}
      <span>
        {{ model.code }}
      </span>
    </div>

    <div class="item-info">
      <span>{{ color }}</span>
      <span>{{ size }}</span>
      <span>{{ product.amount }} шт</span>
    </div>

    <div class="item-prices">
      <div
        v-if="isDiscount"
        class="old-price"
      >
        {{ price.basePrice | price }}
      </div>
      <div :class="['price price-rub', {discount: isDiscount}]">
        {{ price.discountPrice || price.basePrice | price }}
      </div>
    </div>

    <div
      v-if="product.availableOn"
      class="item-access"
    >
      <span>Можно забрать</span> {{ product.availableOn | date({showYear: true}) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'store-card-product',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  computed: {
    model() {
      return this.product.models?.[0] || {};
    },
    media() {
      return this.model.media?.[0] || {};
    },
    color() {
      return this.model.color?.name?.[0]?.toUpperCase() + this.model.color?.name?.slice(1) || '';
    },
    size() {
      return this.model.skus?.find(sku => sku.id === this.product.skuId)?.size;
    },
    price() {
      return this.model.price || {};
    },
    isDiscount() {
      return Number(this.model.price?.discountRate);
    },
  }
};
</script>

<style lang="scss">
.store-card-product {
  display: grid;
  /* stylelint-disable-next-line */
  grid-template-areas:
      "img title"
      "img info"
      "img price"
      "empty access";
  grid-template-columns: auto 1fr;
  width: 100%;
  padding: 12px 10px 9px 0;
  border-bottom: 1px solid $gray_lu;

  .item-img {
    margin-top: 1px;
    margin-right: 9px;
    grid-area: img;
  }

  .item-title {
    grid-area: title;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;

    & > span {
      margin-top: 4px;
      font-size: 10px;
      font-weight: normal;
      line-height: 16px;
      color: $gray;
    }
  }

  .item-info {
    grid-area: info;
    margin-top: 2px;

    & > span {
      display: block;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .item-prices {
    position: relative;
    grid-area: price;
    text-align: right;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;

    .old-price {
      position: absolute;
      top: -85%;
      right: 0;
      color: $gray;
      font-size: 12px;
      line-height: 14px;
      font-weight: normal;
      text-decoration: line-through;
    }
  }

  .item-access {
    grid-area: access;
    margin-top: 3px;
    text-align: left;
    font-size: 11px;
    line-height: 16px;

    & > span {
      color: $blue;
      margin-right: 14px;
    }
  }
}

@include breakpoint("tablet") {
  .store-card-product {
    /* stylelint-disable-next-line */
    grid-template-areas:
      "img title price"
      "img info price"
      "img access price";
    padding: 13px 15px 14px 0;

    .item-img {
      margin-right: 16px;
    }

    .item-title {
      font-size: 16px;
      line-height: 24px;

      & > span {
        margin-top: 1px;
        margin-left: 1px;
        line-height: 12px;
      }
    }

    .item-info {
      margin-top: 16px;
      margin-left: 1px;
    }

    .item-prices {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      font-size: 20px;
      line-height: 24px;

      .old-price {
        position: relative;
        top: auto;
        right: auto;
        font-size: 16px;
        line-height: 16px;
      }

      .price {
        margin-top: 8px;
      }
    }

    .item-access {
      margin-top: 8px;
      font-size: 12px;
      line-height: 16px;

      & > span {
        margin-right: 7px;
      }
    }
  }
}
</style>